/** Marque Loyalty — toujours minuscules (batira), alignée URL + X-Brand. */
export function normalizeLoyaltyBrand(brandName) {
    return String(brandName || "").trim().toLowerCase();
}

export function loyaltyBrandHeaders(brandName) {
    const brand = normalizeLoyaltyBrand(brandName);
    return brand ? { "X-Brand": brand } : {};
}
